import React from 'react';
import { useNavigate } from 'react-router-dom';

import { EVENTS_LIST_ROUTE } from 'constants/routes';
import { ToasterVariant, useToaster } from 'hooks/useToaster';
import { DeleteDraftEventConfirmationModal } from 'pages/dashboard/overview/events/components';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import { useDeleteDraftEventModal } from '@event-editor/hooks/eventEditorState';

const DeleteDraftEventModal = (): React.ReactElement => {
  const event = useEditableEvent();
  const navigate = useNavigate();
  const { showToast } = useToaster();

  const { isOpen, open, close } = useDeleteDraftEventModal();

  return (
    <DeleteDraftEventConfirmationModal
      open={isOpen}
      eventId={event.id!}
      onOpenChange={(v) => (v ? open() : close())}
      onSuccess={(results) => {
        if (results.ok) {
          showToast('Draft event deleted');
          // Close confirmation modal
          close();
          // Navigate to draft events list
          navigate(`${EVENTS_LIST_ROUTE}?tab=draft`);
        } else {
          showToast('Failed to delete draft event', { variant: ToasterVariant.ERROR });
        }
      }}
      onError={() => {
        showToast('Failed to delete draft event', { variant: ToasterVariant.ERROR });
      }}
    />
  );
};

export { DeleteDraftEventModal };
